<template>
  <div id="app">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">
    <div id="logo">
      <img id="logoImg" src="./assets/logo.png" />
      <h6>v{{version}}</h6>
    </div>
    <Login v-if="!api_key"/>
    <div v-if="api_key">
      <div>
        <b-nav align="center">
          <b-nav-item :to="{ name: 'Dashboard'}">Home</b-nav-item>
          <b-nav-item :to="{ name: 'PredictionPage'}">Predictions</b-nav-item>
          <b-nav-item :to="{ name: 'PredictionConfigList'}">Prediction Config</b-nav-item>
          <b-nav-item :to="{ name: 'ReportList'}">Report</b-nav-item>
        </b-nav>
      </div>
    <keep-alive>
      <router-view ></router-view>
    </keep-alive>
  </div>
  </div>
</template>

<script>
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Session from 'vue-cookies'
import Login from './components/Login'
import * as ConfigurationClient from './clients/ConfigurationClient'

Vue.use(BootstrapVue)
export default {
  name: 'app',
  components: {
    Login
  },
  props: {

  },
  data() {
    return {
      version: String,
      api_key: undefined
    }
  },
  async mounted () {
    document.title = process.env.VUE_APP_TITLE
    this.version = require('../config').VERSION
    this.api_key = Session.get('bertiebets.admin.key')
    if (this.api_key) {
      try {
        var response = await ConfigurationClient.getPredictionSettings()
      }catch (err) {
        if (err.response.status === 403) {
          Session.remove('bertiebets.admin.key')
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: 5px;
  font-size: 10pt;
  background-color: #363640;
  color: #FFFFFF;
  min-height: 1000px

}
#logo {

}

#logoImg {
  max-width: 150px
}
.card {
  background-color: #363640
}
h1 {
  font-weight: normal;
  font-size: 12pt;
  height: 64px;
  line-height: 64px;
  vertical-align: middle;
}

h5 {
  text-align:  left;
  font-size: 12pt;
  line-height: 20px;
  vertical-align: middle;
}

h6 {
  font-size: 8pt;
}

.table {
  background-color: #393943;
  color: #FFFFFF;
}

.table td{
  background-color: #393943;
  border-color: #FFFFFF1F ;
  vertical-align: middle;
}

.table tr{
  height: 48px;
}

.table th {
  background-color: #393943;
  border: 1px #FFFFFF1F !important;
  font-weight: normal;
}

.clickable {
  cursor: pointer;
}

.material-icons {
    font-size: 40px;
}

thead {
  color: #FFFFFF96;
}

a {
  color: #FFFFFF
}

.list-group-item {
  background-color: inherit;
  border: none;
  text-align: left
}

.list-group-item-action {
  color: #FFFFFF96
}

.subtitle {
  color: #FFFFFF96;
  text-align: left;
}

.nav {
  margin-bottom: 10px
}

</style>
